var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('resume-personal-information', {
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.resume,
      callback: function ($$v) {
        _vm.$set(_vm.form, "resume", $$v);
      },
      expression: "form.resume"
    }
  }), _c('resume-name', {
    staticClass: "mt-40 mt-lg-60",
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.resume,
      callback: function ($$v) {
        _vm.$set(_vm.form, "resume", $$v);
      },
      expression: "form.resume"
    }
  }), _c('resume-education', {
    staticClass: "mt-40 mt-lg-60",
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.resume,
      callback: function ($$v) {
        _vm.$set(_vm.form, "resume", $$v);
      },
      expression: "form.resume"
    }
  }), _c('resume-work-experience', {
    staticClass: "mt-40 mt-lg-60",
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.resume,
      callback: function ($$v) {
        _vm.$set(_vm.form, "resume", $$v);
      },
      expression: "form.resume"
    }
  }), _c('resume-hash-tags', _vm._b({
    staticClass: "mt-40 mt-lg-60",
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.resume,
      callback: function ($$v) {
        _vm.$set(_vm.form, "resume", $$v);
      },
      expression: "form.resume"
    }
  }, 'resume-hash-tags', {
    hashTags: _vm.hashTags
  }, false)), _c('resume-languages', {
    staticClass: "mt-40 mt-lg-60",
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.resume,
      callback: function ($$v) {
        _vm.$set(_vm.form, "resume", $$v);
      },
      expression: "form.resume"
    }
  }), _c('resume-office-skills', {
    staticClass: "mt-40 mt-lg-60",
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.resume,
      callback: function ($$v) {
        _vm.$set(_vm.form, "resume", $$v);
      },
      expression: "form.resume"
    }
  }), _c('resume-certifications', {
    staticClass: "mt-40 mt-lg-60",
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.resume,
      callback: function ($$v) {
        _vm.$set(_vm.form, "resume", $$v);
      },
      expression: "form.resume"
    }
  }), _c('resume-cover-letter', {
    staticClass: "mt-40 mt-lg-60",
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.resume,
      callback: function ($$v) {
        _vm.$set(_vm.form, "resume", $$v);
      },
      expression: "form.resume"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }